import { TPermission } from '../api/client'

export interface IMenuItem {
    key: string
    title: string
    // Куда ведет: маршрут приложения. Пусто - пункт еще не реализован
    route?: string
    // Право, без которого пункт недоступен
    permission?: TPermission
    // Показывать только когда есть данные счета
    requiresInvoice?: boolean
    hint?: string
}

export interface IMenuSection {
    key: string
    title: string
    icon: string
    color: string
    hint: string
    // Раздел виден только сотрудникам АМГ: клиенту его не показываем вовсе
    staffOnly?: boolean
    items: IMenuItem[]
}

// Структура из раздела 5 ТЗ. Нереализованные пункты показываем неактивными,
// чтобы был виден общий объем сервиса, а не только готовые куски
export const MENU: IMenuSection[] = [
    {
        key: 'payments',
        title: 'Платежи',
        icon: '💳',
        color: '#1c67d9',
        hint: 'Оплата счетов и статусы',
        // Виды операций из ТЗ заказчика. Файл прикладывают не ко всем:
        // перевод себе и между своими счетами заполняются только вручную
        items: [
            { key: 'pay', title: 'Оплата поставщику', route: '/PayInvoice', permission: 'create', hint: 'По счёту или вручную' },
            { key: 'self_card', title: 'Себе на карту', route: '/Payment/self_card', permission: 'create', hint: 'Только вручную' },
            { key: 'between_accounts', title: 'Между своими счетами', route: '/Payment/between_accounts', permission: 'create', hint: 'Только вручную' },
            { key: 'salary', title: 'Выплата зарплаты', route: '/Payment/salary', permission: 'create', hint: 'По ведомости или вручную' },
            { key: 'pending', title: 'Платежи на проверке', route: '/Requests?scope=active' },
            { key: 'history', title: 'История', route: '/Requests?scope=completed' },
        ],
    },
    {
        key: 'documents-out',
        title: 'Выставить документы',
        icon: '🧾',
        color: '#4caf50',
        hint: 'Счета и закрывающие',
        items: [
            { key: 'invoice', title: 'Счёт', route: '/InvoiceForPayment', permission: 'create' },
            { key: 'act', title: 'Акт' },
            { key: 'upd', title: 'УПД' },
            { key: 'waybill', title: 'Накладная' },
            { key: 'facture', title: 'Счёт-фактура' },
        ],
    },
    {
        key: 'documents',
        title: 'Документы',
        icon: '📁',
        color: '#9c27b0',
        hint: 'Хранилище первички',
        items: [
            { key: 'upload', title: 'Загрузить', hint: 'Пока отправляйте файлы прямо в чат боту' },
            { key: 'incoming', title: 'Входящие' },
            { key: 'outgoing', title: 'Исходящие' },
            { key: 'missing', title: 'Не хватает документов' },
        ],
    },
    {
        key: 'taxes',
        title: 'Налоги и отчётность',
        icon: '📊',
        color: '#ff9b00',
        hint: 'Сроки и суммы',
        items: [
            { key: 'to-pay', title: 'К оплате', route: '/Taxes/to_pay', hint: 'Рассчитанные налоги и кнопка оплаты' },
            { key: 'deadlines', title: 'Сроки', route: '/Taxes/upcoming', hint: 'Календарь по вашей системе налогообложения' },
            { key: 'reports', title: 'Сданные отчёты', route: '/Taxes/reports', hint: 'Квитанции и протоколы' },
            // Справку готовит бухгалтер - это заявка из раздела «Задачи бухгалтерии»
            { key: 'certificate', title: 'Запрос справки' },
        ],
    },
    {
        key: 'reconciliation',
        title: 'Сверки и взаиморасчёты',
        icon: '🔄',
        color: '#3f51b5',
        hint: 'Акты сверки и отчёты из 1С',
        items: [
            { key: 'act', title: 'Акт сверки', route: '/Reconciliation/act', hint: 'С контрагентом за период' },
            { key: 'report', title: 'Оборотка и карточка счёта', route: '/Reconciliation/report', hint: 'В рамках разрешённых счетов' },
            { key: 'disputes', title: 'Мои обращения', route: '/Tasks', hint: 'Расхождения и вопросы бухгалтеру' },
        ],
    },
    {
        key: 'staff',
        title: 'Зарплата и кадры',
        icon: '👥',
        color: '#00897b',
        hint: 'Кадровые заявки',
        items: [
            { key: 'send-data', title: 'Передать данные' },
            { key: 'employees', title: 'Сотрудники' },
            { key: 'vacation', title: 'Отпуск' },
            { key: 'sick', title: 'Больничный' },
            { key: 'payroll', title: 'Расчёт' },
        ],
    },
    {
        key: 'consultations',
        title: 'Консультации',
        icon: '📅',
        color: '#00acc1',
        hint: 'Запись к специалисту АМГ',
        items: [
            { key: 'book', title: 'Записаться', route: '/Consultation', hint: 'Тема, специалист и свободное время' },
            { key: 'my', title: 'Мои записи', route: '/MyBookings', hint: 'Перенос и отмена' },
        ],
    },
    {
        key: 'tasks',
        title: 'Задачи бухгалтерии',
        icon: '💬',
        color: '#e91e63',
        hint: 'Обращения вместо чатов',
        items: [
            { key: 'new-request', title: 'Создать запрос' },
            { key: 'my-requests', title: 'Мои обращения' },
            { key: 'urgent', title: 'Срочный вопрос' },
        ],
    },
    {
        key: 'company',
        title: 'Моя компания',
        icon: '🏢',
        color: '#607d8b',
        hint: 'Реквизиты и доступы',
        items: [
            { key: 'requisites', title: 'Реквизиты' },
            { key: 'contract', title: 'Договор' },
            { key: 'tariff', title: 'Тариф' },
            { key: 'contacts', title: 'Контакты' },
            { key: 'users', title: 'Пользователи' },
        ],
    },
    {
        key: 'admin',
        title: 'Администрирование',
        icon: '🛠',
        color: '#455a64',
        hint: 'Базы, доступы, очередь',
        staffOnly: true,
        items: [
            { key: 'bases', title: 'Базы 1С', route: '/Admin/bases', hint: 'Подключение и выгрузка справочников' },
            { key: 'orgs', title: 'Организации', route: '/Admin/orgs', hint: 'Лимиты и доступные счета' },
            { key: 'users', title: 'Пользователи', route: '/Admin/users', hint: 'Роли, доступы, приглашения' },
            { key: 'queue', title: 'Очередь и ошибки', route: '/Admin/queue', hint: 'Перезапуск заявок' },
            { key: 'stats', title: 'Статистика', route: '/Admin/stats', hint: 'Операции и активность' },
        ],
    },
    {
        key: 'help',
        title: 'Помощь',
        icon: '❓',
        color: '#795548',
        hint: 'Инструкции и поддержка',
        items: [
            { key: 'manuals', title: 'Инструкции' },
            { key: 'faq', title: 'Частые вопросы' },
            { key: 'human', title: 'Связаться с человеком' },
        ],
    },
]

export const findSection = (key: string): IMenuSection | undefined => MENU.find(s => s.key === key)

// Разделы, доступные роли: административный виден только сотрудникам АМГ
export const menuFor = (role?: string): IMenuSection[] =>
    MENU.filter(section => !section.staffOnly || role === 'admin' || role === 'head')
